<template>
    <form-builder :url="url" :method="method" :fields="fields" :argsdata="args.formobjects" :success="onSuccess"></form-builder>
</template>

<script>
    import FormBuilder from '../../frontend/components/FormBuilder';
    export default {
        components: {
            FormBuilder
        },
        props: {
            args: Object
        },
        methods: {
            onSuccess() {
                location.href = "/external_leagues";
            }
        },
        data() {
            return {
                url: '/external_leagues/' + this.args.formobjects.id,
                method: 'patch',
                fields: [
                    [
                        {type: 'text', name: 'name', label: __('external_leagues.league_name')},
                        {type: 'password', name: 'password', label: __('external_leagues.league_password')},
                    ],
                    [
                        {type: 'text', name: 'description', label: __('external_leagues.description_optional')},
                        {type: 'password', name: 'password_confirmation', label: __('external_leagues.league_password_confirm')},

                    ],
                    [
                        {type: 'text', name: 'link', label: __('external_leagues.league_link_optional')},
                        {type: 'submit', name: __('external_leagues.create_league')}
                    ]
                ]
            }

        }
    }
</script>
